import React from "react";
import i18next from "i18next";
import { WmsInput } from "./WmsInput";
import { WmsLayers } from "./WmsLayers";
import { AccordionItem } from "../../Elements/Accordion";
import { useMapContext } from "../../Contexts/MapContext";
import { DrawingSection } from "../enums";
import { useDrawingContext } from "../../Contexts/DrawingContext";
import "./WmsAddition.scss";

export const WmsAddition = (): JSX.Element => {
    const { wmsState } = useMapContext();
    const { toolsExpanded, setToolExpanded } = useDrawingContext();

    return (
        <AccordionItem
            title={i18next.t("addWms.wmsLayers")}
            changeHeight={Date.now()}
            key="addWms"
            defaultExpanded={toolsExpanded.includes(DrawingSection.WMS) ? Math.random() : null}
            onExpand={(exp: boolean) => setToolExpanded(DrawingSection.WMS, exp)}
        >
            <WmsInput />
            {wmsState.length ? <WmsLayers /> : null}
        </AccordionItem>
    );
};
